import React from 'react';
import {Alert, TextInput, View} from 'react-native';
import {connect} from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";
import AsyncStorage from '@react-native-async-storage/async-storage';

import {StackNavigationProp} from "@react-navigation/stack";
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import HttpRequest from "../utils/HttpRequest";
import IClient from "../Models/Client/IClient";
import {saveClients} from "../Models/Client/ClientActions";
import {saveCouriers} from "../Models/Courier/CourierActions";
import ICourier from "../Models/Courier/ICourier";
import IUser from "../Models/User/IUser";
import {saveUser} from "../Models/User/UserActions";
import AppButton from "../Components/AppButton";
import {EUserType} from "../Models/User/EUserType";


type navProps = StackNavigationProp< any, 'Login'>;
interface IProps {
    navigation:navProps;
    saveClients:(clients:IClient[])=>AnyAction
    saveCouriers:(couriers:ICourier[])=>AnyAction
    saveUser:(user:IUser)=>AnyAction
}
interface IState {
    userName:string,
    password:string,
    isLoading:boolean;
    isError:boolean,
    errorText:string

}

class Login extends React.Component<IProps> {

    state:IState={
        userName:'',
        password:'',
        isError:false,
        isLoading:false,
        errorText:''
    }
    componentDidMount() {
        AsyncStorage.removeItem('user')
        AsyncStorage.removeItem('token')
    }
    login(){
        this.setState({isError:false,errorText:""})

        if(this.state.userName=='' || this.state.password==''){
            this.setState({isError:true,errorText:"נא להכניס שם משתמש וסיסמה"})
            return;
        }
        this.setState({isLoading:true})
        HttpRequest('users/login',"POST",{userName:this.state.userName,password:this.state.password}).then( async (result)=>{
            if(result.status==200){
                let user:IUser=result.data.user;
                let token=result.data.token;
                await AsyncStorage.setItem('user',JSON.stringify(user))
                await AsyncStorage.setItem('token',token)
                this.props.saveUser(user);
                if(user.type==EUserType.admin){
                    this.props.navigation.navigate('Clients')
                    return;
                }
                this.props.navigation.navigate('OrderHistory')
                return;
            }
            this.setState({isLoading:false})

            this.setState({isError:true,errorText:"שגיאת רשת נא לנסות שוב"})

        }).catch(e=>{

            this.setState({isLoading:false})

            if(e.hasOwnProperty("status") && e.status==401){
                this.setState({isError:true,errorText:"שם משתמש או סיסמה אינם נכונים"})
                return;
            }
            this.setState({isError:true,errorText:"שגיאת רשת נא לנסות שוב"})
        }).finally(()=>this.setState({isLoading:false}))
    }
    fetchData(userType:EUserType){
        HttpRequest('clients',"GET").then((result)=>{

            this.props.saveClients(result.data)
            HttpRequest('couriers',"GET").then((result)=>{
                this.setState({isLoading:false})
                this.props.saveCouriers(result.data);
                if(userType==EUserType.admin){
                    this.props.navigation.navigate('Clients')
                    return;
                }
                this.props.navigation.navigate('OrderHistory')
            }).catch(e=>{
                this.setState({isLoading:false})
            })
        }).catch(e=>{
            this.setState({isLoading:false})
        })
    }
    render() {
        return(
            <View style={{display:'flex',flexDirection:'column',alignItems:'center',paddingTop:170,backgroundColor:'#01B271',flex:1,width:'100%'}}>
                <TextInput
                    placeholderTextColor={'#989898'}
                    value={this.state.userName}
                    onChangeText={(text)=>this.setState({userName:text})}
                    autoCapitalize="none"
                    autoCorrect={false}
                    autoComplete="username"
                    style={{width:'70%',height:50,backgroundColor:'#D4F8EB',borderRadius:25,textAlign:'right',paddingLeft:15,paddingRight:15,fontSize:16}}
                    placeholder={'שם משתמש'}
                />
                <TextInput
                    placeholderTextColor={'#989898'}
                    value={this.state.password}
                    secureTextEntry={true}
                    onChangeText={(text)=>this.setState({password:text})}
                    autoCapitalize="none"
                    autoCorrect={false}
                    autoComplete="password"
                    style={{width:'70%',height:50,backgroundColor:'#D4F8EB',borderRadius:25,marginTop:10,marginBottom:20,textAlign:'right',paddingLeft:15,paddingRight:15,fontSize:16}}
                    placeholder={'סיסמה'}
                />
                <HideableView hidden={!this.state.isError}>
                    <AppText style={{color:'red',fontSize:17,marginBottom:10,fontWeight:'700'}}>{this.state.errorText}</AppText>
                </HideableView>
                <AppButton isLoading={this.state.isLoading} fontSize={20} text={'התחבר'} onPress={()=>this.login()} height={40} width={120} color={'#373737'}/>
            </View>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {

    };
};

const mapDispatchToProps ={

    saveClients:saveClients,
    saveCouriers:saveCouriers,
    saveUser:saveUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
